import Bars from './bars.component';
export default Bars;
